// extracted by mini-css-extract-plugin
export default {"icon":"PrivacyItem_icon__q6-Sn","item":"PrivacyItem_item__Z5WE-"};